import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { childNodes } from 'Helpers/PropTypes';
import './index.css';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  panelSummary: {
    padding: theme.spacing(0),
  },
  panelDetail: {
    flexDirection: 'column',
    padding: theme.spacing(1, 0),
  },
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

export default function Section({ label, children, className }) {
  const classes = useStyles();

  function getClassNames() {
    return classnames({
      light: true,
      [className]: true,
    });
  }

  return (
    <div className={getClassNames()}>
      <ExpansionPanel elevation={0}>
        <ExpansionPanelSummary
          className={classes.panelSummary}
          expandIcon={<ExpandMoreIcon color="primary" />}
        >
          <Typography color="primary" variant="h2" className={classes.bold}>
            {label}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.panelDetail}>
          {children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

Section.propTypes = {
  label: PropTypes.string,
  children: childNodes.isRequired,
  className: PropTypes.string,
};

Section.defaultProps = {
  label: '',
  className: '',
};
